import { useTranslationUserProfiles } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import { HeaderBar } from '@dealstack/frontend/shared/components/HeaderBar/HeaderBar';
import { ManagePersonalDetails } from '@dealstack/frontend/shared/components/Profile/PersonalDetails/ManagePersonalDetails/ManagePersonalDetails';

const PersonalDetails = () => {
	const tUserProfiles = useTranslationUserProfiles();
	return (
		<div>
			<HeaderBar tabSectionName={tUserProfiles('personal_details.section_name')}></HeaderBar>
			<ManagePersonalDetails />
		</div>
	);
};
const _PersonalDetailsExport = memo(PersonalDetails);

export { _PersonalDetailsExport as PersonalDetails };
